module.exports = __webpack_public_path__ + "static/tvingthumb-e3e5e6a6dcb12c4e2a26b6263e1ebcdc.jpg";